import React, { useState, useEffect } from 'react';
import { BottomNavigationAction, BottomNavigation, Paper } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import PersonIcon from '@mui/icons-material/Person';
import SwipeIcon from '@mui/icons-material/Swipe';

import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

export default function BottomNav() {
  const [value, setValue] = useState(0);

  const location = useLocation();


  useEffect(() => {
    if (location.pathname.startsWith('/categories')) {
      setValue(0);
    } else if (location.pathname.startsWith('/products')) {
      setValue(1);
    } else if (location.pathname.startsWith('/swipe')) {
      setValue(2);
    }
    else if (location.pathname.startsWith('/liked')) {
      setValue(3);
    }
  }, [location.pathname]);

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 8, // Floating above the bottom
        left: '50%',
        transform: 'translateX(-50%)', // Center horizontally
        width: '85%', // Adjust width for pill shape
        maxWidth: 400, // Optional: Limit max width
        borderRadius: 50, // Makes it pill-shaped
        overflow: 'hidden',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)', // Adds a shadow for the floating effect
        zIndex: 10, // Ensures it stays above other elements
      }}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(_, v) => setValue(v)}
        sx={{
          backgroundColor: 'white', // Background color of the nav
          borderRadius: 50, // Ensures the inner nav matches the pill shape
        }}
      >
        <BottomNavigationAction
          component={Link}
          to="/categories"
          label="Home"
          icon={<HomeIcon />}
        />
        <BottomNavigationAction
          component={Link}
          to="/products"
          label="Search"
          icon={<SearchIcon />}
        />
        {/* <BottomNavigationAction
          component={Link}
          to="/swipe"
          label="Swipe"
          icon={<SwipeIcon />}
        /> */}
        <BottomNavigationAction
          component={Link}
          to="/liked"
          label="Profile"
          icon={<PersonIcon />}
        />
      </BottomNavigation>
    </Paper>
  );
}